import { render, staticRenderFns } from "./header-app-menu.vue?vue&type=template&id=96552d64&scoped=true&"
import script from "./header-app-menu.vue?vue&type=script&lang=js&"
export * from "./header-app-menu.vue?vue&type=script&lang=js&"
import style0 from "./header-app-menu.vue?vue&type=style&index=0&id=96552d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96552d64",
  null
  
)

export default component.exports